/**
 * @file - AdvertTemplate.tsx
 * @description вставка баннера на страницу
 *    (AD_FOX advertising, рекламные баннеры)
 * @param type - используемый тип баннера, один из TypeAd
 * @param count - лучше передавать ID, I, INDEX
 *    для использования нескольких шаблонов с аттрибутами id={id} на одной странице
 * @param container
 * @param className
 */

import s from './AdvertTemplate.module.sass'

import { SHOW_ANY_ADV } from './config'
import { useAdvertTemplate } from './hooks/useAdvertTemplate'
import type { AdvertTemplateProps } from './types'

import { FC, memo } from 'react'

import { PlugAds } from '@widgets/Common/PlugAds'

export type { TypeAd } from './config'

const passThroughContainer: FC<{ children?: React.ReactNode }> = ({ children }) => <>{children}</>

const AdvertTemplate: FC<AdvertTemplateProps> = (props) => {
  const {
    type,
    count = null,
    container,
    className = '',
    singleRequest = false,
    scrollLoadParam,
    onEmptyAdv,
    onLoadedAdv,
  } = props

  const Container = container ?? passThroughContainer

  const { typeCurrent, effectiveShowAdv, showPlugAds, isDev, nodeId, dynamicCount, inlineStyles } = useAdvertTemplate({
    type,
    count,
    singleRequest,
    scrollLoadParam,
    onEmptyAdv,
    onLoadedAdv,
  })

  const thisClassName = `${s.advert} ${className} ${!effectiveShowAdv ? s['visually-hidden'] : ''} ${
    isDev ? s['advert--is-dev'] : ''
  }`

  const renderAdvertView = () => (
    <Container>
      <div className={s['advert-wrap']}>
        <div className={thisClassName} style={inlineStyles} id={nodeId} data-id={dynamicCount} />
        {isDev && <span className={s['advert-text']}>{typeCurrent}</span>}
      </div>
    </Container>
  )

  const renderPlugAdsView = () => (
    <Container>
      <PlugAds className={className} />
    </Container>
  )

  const view = [
    SHOW_ANY_ADV && effectiveShowAdv === true && renderAdvertView(),
    SHOW_ANY_ADV && showPlugAds && renderPlugAdsView(),
  ].find(Boolean)

  return view ?? null
}

export default memo(AdvertTemplate)
